module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "table-card pl-box-shadow"
  }, [_c('div', {
    staticClass: "table-card-title mb3 center-xs middle-xs flex"
  }, [_c('span', {
    staticClass: "mr3"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('i', {
    directives: [{
      name: "my-tooltip",
      rawName: "v-my-tooltip.left",
      value: (_vm.tooltip),
      expression: "tooltip",
      modifiers: {
        "left": true
      }
    }],
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "color": "#848484",
      "font-size": "14px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), (_vm.tableKey === 'activeTeacher') ? _c('div', {
    staticClass: "table-data overflow-auto start-xs"
  }, _vm._l((_vm.analyticsMostActiveTeachers), function(teacher, index) {
    return _c('div', {
      key: teacher.id,
      staticClass: "row w-100 no-margin pb3"
    }, [_c('div', {
      staticClass: "row col-xs-9 no-padding ellipsis"
    }, [_c('span', {
      staticClass: "col-xs-2 w-100 tl",
      staticStyle: {
        "padding-right": "0"
      }
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('span', {
      staticClass: "col-xs-10 no-padding table-data-name clickable",
      on: {
        "click": function($event) {
          return _vm.openUserDetails(teacher)
        }
      }
    }, [_vm._v("\n            " + _vm._s(teacher.name) + "\n          ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3 no-padding ellipsis end-xs"
    }, [_vm._v("\n          " + _vm._s(teacher.rts_count) + " RTs\n        ")])])
  }), 0) : (_vm.tableKey === 'inactiveTeacher') ? _c('div', {
    staticClass: "table-data overflow-auto start-xs"
  }, _vm._l((_vm.analyticsInactiveTeachers), function(teacher, index) {
    return _c('div', {
      key: teacher.id,
      staticClass: "row w-100 no-margin pb3"
    }, [_c('div', {
      staticClass: "row col-xs-9 no-padding"
    }, [_c('span', {
      staticClass: "col-xs-2 w-100 tl",
      staticStyle: {
        "padding-right": "0"
      }
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('span', {
      staticClass: "col-xs-10 no-padding table-data-name clickable ellipsis",
      on: {
        "click": function($event) {
          return _vm.openUserDetails(teacher)
        }
      }
    }, [_vm._v("\n            " + _vm._s(teacher.name) + "\n          ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3 no-padding ellipsis end-xs"
    }, [_vm._v("\n          " + _vm._s(teacher.rts_count) + " RTs\n        ")])])
  }), 0) : (_vm.tableKey === 'recentTopicsUsed') ? _c('div', {
    staticClass: "table-data overflow-auto start-xs"
  }, _vm._l((_vm.analyticsRecentTopicsUsed), function(topic) {
    return _c('div', {
      key: topic.id,
      staticClass: "row w-100 no-margin pb3"
    }, [_c('div', {
      staticClass: "col-xs-12 no-padding table-data-name clickable ellipsis-topics-used",
      on: {
        "click": function($event) {
          return _vm.goToUniversePremade(topic.id)
        }
      }
    }, [_vm._v("\n          " + _vm._s(topic.title) + "\n          "), _c('i', {
      staticClass: "fas fa-external-link-alt",
      staticStyle: {
        "font-size": "6px",
        "vertical-align": "top"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "mt1 f7"
    }, [_c('span', {
      staticClass: "b"
    }, [_vm._v("Used By: ")]), _vm._v(" "), _vm._l((topic.users), function(user, index) {
      return _c('span', {
        key: user.index
      }, [_vm._v("\n            " + _vm._s(index + 1 !== topic.users.length ? user + ', ' : user) + "\n          ")])
    })], 2)])
  }), 0) : _c('div', {
    staticClass: "table-data overflow-auto start-xs"
  }, _vm._l((_vm.analyticsTopUniversePortfolios), function(teacher, index) {
    return _c('div', {
      key: teacher.profile_url,
      staticClass: "row w-100 no-margin pb3"
    }, [_c('div', {
      staticClass: "row col-xs-8 no-padding"
    }, [_c('span', {
      staticClass: "col-xs-2 w-100 tl",
      staticStyle: {
        "padding-right": "0"
      }
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('span', {
      staticClass: "col-xs-10 no-padding table-data-name clickable ellipsis",
      on: {
        "click": function($event) {
          return _vm.goToUniversePortfolio(teacher)
        }
      }
    }, [_vm._v("\n            " + _vm._s(teacher.name) + "\n            "), _c('i', {
      staticClass: "fas fa-external-link-alt",
      staticStyle: {
        "font-size": "6px",
        "vertical-align": "top"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-4 no-padding ellipsis end-xs"
    }, [_vm._v("\n          " + _vm._s(teacher.topics_count) + " Topics\n        ")])])
  }), 0)]), _vm._v(" "), (_vm.openDetailsUserID) ? _c('user-details-modal', {
    attrs: {
      "userId": _vm.openDetailsUserID,
      "userSchool": _vm.userSchool
    },
    on: {
      "close": function($event) {
        _vm.openDetailsUserID = ''
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-3341cd80!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/adminPortal/analytics/adminPortalAnalyticsTableCard.vue
// module id = 2145
// module chunks = 61